export class Utils {

    static getURLParameter(name) {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
    }

    static vec3ToString(vec3) {
        return `${vec3.x},${vec3.y},${vec3.z}`;
    }

    static quatToString(quat) {
        return `${quat.x},${quat.y},${quat.z},${quat.w}`;
    }

    static parseVec3(str) {
        const values = str.split(',').map(parseFloat);
        return new pc.Vec3(values[0], values[1], values[2]);
    }

    static parseQuat(str) {
        const values = str.split(',').map(parseFloat);
        return new pc.Quat(values[0], values[1], values[2], values[3]);
    }

    static parseGraphNode(graphNode) {
        function traverseNode(node) {
            // Store node information
            let nodeInfo = {
                name: node.name,
                position: Utils.vec3ToString(node.getLocalPosition()),
                rotation: Utils.quatToString(node.getLocalRotation()),
                scale: Utils.vec3ToString(node.getLocalScale()),
                enabled: node.enabled,
                children: []
            };

            if(node.animation && node.animation.playing){
                nodeInfo.animation = {
                    currAnim: node.animation.currAnim,
                    currTime: node.animation.currTime,
                    loop: node.animation.loop
                }
            }
            
            // Recursively traverse children nodes
            for (let i = 0; i < node.children.length; i++) {
                nodeInfo.children.push(traverseNode(node.children[i]));
            }
            
            return nodeInfo;
        }
        
        return traverseNode(graphNode);
    }

    static displayGraphNode(graphNode) {
        function traverseNode(node) {
            // Store node information
            let nodeInfo = {
                name: node.name,
                children: []
            };

			console.log(node.name);
            
            // Recursively traverse children nodes
            for (let i = 0; i < node.children.length; i++) {
                nodeInfo.children.push(traverseNode(node.children[i]));
            }
            
            return nodeInfo;
        }
        
        return traverseNode(graphNode);
    }

    static applyJSONToGraphNode(jsonData, targetNode) {
		if(!targetNode)
			return;
        function traverseNode(data, node) {
            // Apply node properties
            node.name = data.name;
            const position = Utils.parseVec3(data.position);
            const rotation = Utils.parseQuat(data.rotation);
            const scale = Utils.parseVec3(data.scale);
            node.setLocalPosition(position);
            node.setLocalRotation(rotation);
            node.setLocalScale(scale);
            node.enabled = data.enabled;

            // Recursively traverse and apply properties to children nodes
            for (let i = 0; i < data.children.length; i++) {
                const childNodeData = data.children[i];
                const childNode = node.children[i];
                traverseNode(childNodeData, childNode);
            }
        }

        traverseNode(jsonData, targetNode);
    }

    static getMediaType(name) {
      let mediaType = '';
      const ext = /[^.]+$/.exec(name)[0].toLowerCase();
      switch (ext) {
        case 'png': case 'jpg': case 'jpeg': case 'gif':
          mediaType = 'img';
          break;
        case 'mp4': case 'webm':
          mediaType = 'vid'
        break;
      }
      return mediaType;
    }

    static createUUID() {
      var dt = new Date().getTime();
      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
      return uuid;
    }
}   